<template>
  <div id="primary-insurance">
    <div class="primary-insurance-view">
      <div class="step-inner-navbar"></div>
      <div class="step-inner-content">
        <div class="vue-form">
          <el-form v-model="primaryInsuranceForm">
            <el-row :gutter="15">
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">
                      Relationship
                      <span class="star">*</span>
                    </label>
                    <el-select
                      v-model="primaryInsuranceForm.relationship"
                      @change="fillPrimaryDetails()"
                      @clear="clearNameSerach"
                      placeholder="Select Relationship"
                      filterable
                      clearable
                      default-first-option
                      
                    >
                      <el-option
                        v-for="(type, index) in relationships"
                        :key="index"
                        :value="type"
                        :label="type"
                      ></el-option>
                    </el-select>
                    <p class="err">
                      <FormError
                        errorName="case_data.billing_info.insurance.primary_insurance.relationship"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">
                      Plan Type
                    </label>
                    <el-select
                      placeholder="Select Plan Type"
                      filterable
                      v-model="primaryInsuranceForm.plan_type"
                      default-first-option
                      
                    >
                      <el-option
                        v-for="(type, index) of planTypes"
                        :key="index"
                        :value="type"
                        :label="type"
                      ></el-option>
                    </el-select>
                    <p class="err">
                      <FormError
                        errorName="case_data.billing_info.insurance.primary_insurance.plan_type"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">
                      First Name
                      <span class="star">*</span>
                    </label>
                    <el-input
                      v-model="primaryInsuranceForm.first_name"
                      placeholder="Enter First Name"
                      
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="case_data.billing_info.insurance.primary_insurance.first_name"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text"> Middle Name </label>
                    <el-input
                      v-model="primaryInsuranceForm.middle_name"
                      placeholder="Enter Middle Name"
                      
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="case_data.billing_info.insurance.primary_insurance.middle_name"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">
                      Last Name
                      <span class="star">*</span>
                    </label>
                    <el-input
                      v-model="primaryInsuranceForm.last_name"
                      placeholder="Enter Last Name"
                      
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="case_data.billing_info.insurance.primary_insurance.last_name"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="2" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input gender-group">
                  <el-form-item>
                    <label for="text"> Gender </label>
                    <el-select
                      v-model="primaryInsuranceForm.gender"
                      placeholder="Select Gender"
                      filterable
                      default-first-option
                      
                      clearable
                    >
                      <el-option
                        v-for="(gender, index) in genderOptions"
                        :key="index"
                        :label="gender"
                        :value="gender"
                      ></el-option>
                    </el-select>
                    <p class="err">
                      <FormError
                        errorName="case_data.billing_info.insurance.primary_insurance.gender"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="date-of-birth case-creation__input">
                  <el-form-item>
                    <dobVersion
                      v-if="showPatientDob"
                      :dobData="primaryInsuranceForm"
                      :validataionErrors="getErrors"
                      :errorKey="'case_data.billing_info.insurance.primary_insurance.date_of_birth'"
                      :displayRequired="false"
                    >
                    </dobVersion>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <payor
                      v-if="show"
                      :payorData="primaryInsuranceForm"
                      :validataionErrors="getErrors"
                      :clearPayor="clearPayorData"
                      insuranceType="primary_insurance"
                    >
                    </payor>
                    <p class="err">
                      <FormError
                        errorName="case_data.billing_info.insurance.primary_insurance.payor"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">
                      Policy No
                      <span class="star">*</span>
                    </label>
                    <el-input
                      v-model="primaryInsuranceForm.policy_id"
                      placeholder="Enter Policy No"
                      
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="case_data.billing_info.insurance.primary_insurance.policy_id"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">Group #</label>
                    <el-input
                      v-model="primaryInsuranceForm.group"
                      placeholder="Enter Group #"
                      
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="case_data.billing_info.insurance.primary_insurance.group"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text"> Address Line 1 </label>
                    <el-input
                      v-model="primaryInsuranceForm.address_line_1"
                      placeholder="Enter Address Line 1"
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="case_data.billing_info.insurance.primary_insurance.address_line_1"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text"> Address Line 2 </label>
                    <el-input
                      v-model="primaryInsuranceForm.address_line_2"
                      placeholder="Enter Address Line 2"
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="case_data.billing_info.insurance.primary_insurance.address_line_2"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text"> Zip </label>
                    <el-input
                      v-model="primaryInsuranceForm.zip"
                      placeholder="Enter Zip"
                      maxlength="5"
                      @input="getStateCity"
                      
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="case_data.billing_info.insurance.primary_insurance.zip"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="2" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <state
                      :stateData="primaryInsuranceForm"
                      :displayRequired="false"
                    ></state>
                    <p class="err">
                      <FormError
                        errorName="case_data.billing_info.insurance.primary_insurance.state"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <city
                      :cityData="primaryInsuranceForm"
                      v-if="show"
                      :displayRequired="false"
                    ></city>
                    <p class="err">
                      <FormError
                        errorName="case_data.billing_info.insurance.primary_insurance.city"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import caseConstants from "@/config/constants/caseConstants";
const payor = defineAsyncComponent(() => import("@/components/misc/Payor"));
const dobVersion = defineAsyncComponent(() =>
  import("@/components/misc/DobNewFormat")
);
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
const state = defineAsyncComponent(() => import("@/components/misc/State"));
const city = defineAsyncComponent(() => import("@/components/misc/City"));
import AppHelper from "@/mixins/AppHelper";
import InsuranceHelper from "@/mixins/InsuranceHelper";

import { mapGetters } from "vuex";
export default {
  props: ["caseInformation", "primaryInsurance", "refreshDob"],
  data() {
    return {
      primaryInsuranceForm: JSON.parse(JSON.stringify(caseConstants.insurance)),
      relationships: caseConstants.BILLING_RELATIONSHIPS,
      planTypes: ["INDIVIDUAL", "FAMILY"],
      genderOptions: ["MALE", "FEMALE"],
      payorData: {},
      show: false,
      showPatientDob: false,
      caseId: "",
      clearPayorData: false,
    };
  },
  components: {
    FormError,
    payor,
    dobVersion,
    state,
    city,
  },
  mixins: [AppHelper, InsuranceHelper],
  computed: {
    ...mapGetters("pendingCases", ["getsinglePatientDetails"]),
    ...mapGetters("errors", ["getErrors"]),
    ...mapGetters("cases", ["getStateAndCity"]),
  },
  mounted() {
    this.fetchStates();
    this.show = true;
    this.showPatientDob = true;
    if (this.primaryInsurance) {
      this.primaryInsuranceForm = { ...this.primaryInsurance };
    }
    if (this.$route.params.case_id) {
      this.caseId = this.$route.params.case_id;
      this.checkCaseInfo();
    }
  },

  methods: {
    async getStateCity() {
      try {
        let params = {
          zip: this.primaryInsuranceForm.zip,
        };
        await this.$store.dispatch("cases/getStateCity", params);
        if (this.getStateAndCity) {
          this.primaryInsuranceForm.state = this.getStateAndCity.state;
          this.primaryInsuranceForm.city = this.getStateAndCity.city;
        } else {
          if (!this.getStateAndCity && params.zip.length == 5) {
            this.$message({
              message: "No State & City Found",
              type: "warning",
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchStates() {
      await this.$store.dispatch("help/fetchAllStates");
    },
    getPrimaryInsuranceFormData() {
      return this.getFormattedValues(this.primaryInsuranceForm);
    },
    checkCaseInfo() {
      if (
        this.getsinglePatientDetails.billing_info &&
        this.getsinglePatientDetails.billing_info.insurance &&
        this.getsinglePatientDetails.billing_info.insurance.primary_insurance
      ) {
        this.primaryInsuranceForm = this.setInsuranceDataFromBackendData(
          this.getsinglePatientDetails.billing_info.insurance.primary_insurance
        );
        this.payorData =
          this.getsinglePatientDetails.billing_info.insurance.primary_insurance
            .payor || {};
        this.getsinglePatientDetails.billing_info.insurance.primary_insurance;
      }
    },
    clearNameSerach() {
      this.primaryInsuranceForm = {
        relationship: "",
        plan_type: "",
        payor: "",
        insurance_code: "",
        gender: "",
        date_of_birth: "",
        policy_plan: "",
        group_or_plan: "",
        group: "",
        patient_policy: "",
        address_line_1: "",
        address_line_2: "",
        city: "",
        state: "",
        zip: "",
        first_name: "",
        middle_name: "",
        last_name: "",
      };
      this.clearPayorData = true;
      setTimeout(() => {
        this.show = true;
      }, 100);
    },
    fillPrimaryDetails() {
      this.clearPayorData = false;
      if (this.primaryInsuranceForm.relationship === "Self") {
        this.showPatientDob = false;
        let patientInformation = this.caseInformation;

        this.primaryInsuranceForm.first_name = patientInformation.first_name;
        this.primaryInsuranceForm.middle_name = patientInformation.middle_name;
        this.primaryInsuranceForm.last_name = patientInformation.last_name;
        this.primaryInsuranceForm.gender = patientInformation.gender;

        this.primaryInsuranceForm.date_of_birth =
          patientInformation.date_of_birth;

        this.primaryInsuranceForm.city = patientInformation.city;
        this.primaryInsuranceForm.state = patientInformation.state;
        this.primaryInsuranceForm.zip = patientInformation.zip;
        this.primaryInsuranceForm.address_line_1 =
          patientInformation.address_line_1;
        this.primaryInsuranceForm.address_line_2 =
          patientInformation.address_line_2;

        setTimeout(() => {
          this.show = true;
          this.showPatientDob = true;
        });
      }
    },
  },
  watch: {
    refreshDob: {
      immediate: true,
      deep: true,
      handler: function () {
        this.showPatientDob = this.refreshDob;
      },
    },
  },
};
</script>
